import React, {Component} from "react";
import {Button, Col, Form, FormControl, Modal, Row} from "react-bootstrap";
import {ReactComponent as EditSvg} from "../../images/edit-regular.svg";
import Axios from "axios";

export default class EditImageModal extends Component {

    state = {}

    onSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        console.log(form["boardImg"])
        if(form["boardImg"] && form["boardImg"].files && form["boardImg"].files.length){
            for(let img of form["boardImg"].files){
                data.append("boardImg",img);
            }
        }
        data.append("boardImgUrl",this.state.imageURL ?  this.state.imageURL: "");
        data.append("campaignId",this.props.campaignId ? this.props.campaignId : "");
        data.append("boardId",this.props.boardId ? this.props.boardId : "");
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/edit-image", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            let cb = this.props.handleImageChange
            setTimeout(function (){
                cb(response.data.board);
            },2000)//give time to upload board to s3
            this.props.onHide();
        }).catch(error => {
            console.log(error.message)
            console.log(error.response)
        });
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Form onSubmit={this.onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Images</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Upload an image from a url or images from files.
                    <Row className={"mt-2"}>
                        <Col className={"text-center col-5"}>
                            <FormControl
                                placeholder="Image URL"
                                aria-label="Image URL"
                                aria-describedby="basic-addon2"
                                value={this.state.imageURL}
                                onChange={e => this.setState({ imageURL: e.target.value })}
                            />
                        </Col>
                        <Col className={"text-center col-1 mt-1"}>
                            Or
                        </Col>
                        <Col className={"text-center col-6 mt-1"}>
                            <FormControl type="file" name="boardImg" accept={"image/*,.pdf"} multiple/>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <span onClick={this.props.onHide} className={"me-4 boring-btn"}>Close</span>
                    <Button variant="primary" type="submit">
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    }
}
